interface ApiConstantsInterface {
  baseUrl: string
  productSettings: string
  assign: string
  media: string
}

const apiConstants: ApiConstantsInterface = {
  baseUrl: '/api/productassignment',
  productSettings: `/settings/product`,
  assign: '/assign',
  media: '/media',
}

export { apiConstants, ApiConstantsInterface }
